export function removeNullValues(obj) {
  // Handle null
  if (obj === null) {
    return null;
  }

  // Return Date objects as is
  if (obj instanceof Date) {
    return obj;
  }

  // Handle non-object inputs (but not dates)
  if (typeof obj !== 'object') {
    return obj;
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    return obj
      .map((item) => removeNullValues(item))
      .filter((item) => item !== null);
  }

  // Handle objects
  const result = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = removeNullValues(obj[key]);

      if (value !== null) {
        result[key] = value;
      }
    }
  }

  return result;
}
